module.exports = __webpack_public_path__ + "static/logo-13a1f3db3c2a1d1d8c14286b0c5b15f3.png";